<template>
	<i class="icon-fysiekebelasting"></i>
</template>

<script>
	export default {
		name: 'IconPhysicalStrain'
	};
</script>
